import { render, staticRenderFns } from "./transition.vue?vue&type=template&id=01a20b8a&scoped=true&"
import script from "./transition.vue?vue&type=script&lang=js&"
export * from "./transition.vue?vue&type=script&lang=js&"
import style0 from "./transition.vue?vue&type=style&index=0&id=01a20b8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a20b8a",
  null
  
)

export default component.exports